import React from 'react';
import '../template-file-css/document-file-template.css';


export const BRC_ProgressNote = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='BRC_ProgressNote' className='file-pdf-document'>
            <div className='file-template'>

                <p>
                    <center>
                        <h3>Progress Note</h3>
                    </center>
                </p>


                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Name:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>DOB:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Date:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtName' name='txtName' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtDob' name='txtDob' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtDate' name='txtDate' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'><span className='eleHeader'>Current Address:</span></td>
                        <td className='w-250'><span className='eleHeader'>Current Phone Number:</span></td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtCurrentAddress' name='txtCurrentAddress' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtCurrentPhoneNumber' name='txtCurrentPhoneNumber' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Allergic to:</span>
                    <textarea id='txtAllergicTo' name='txtAllergicTo' className='add-only'></textarea>
                </p>
                <p>
                    <h3>CURRENT LIST OF MEDICATIONS</h3>
                </p>

                <table>


                    <tr>
                        <td className='w-200'> <span className='eleHeader'>MEDICATION:</span> </td>
                        <td className='w-150'> <span className='eleHeader'>DOSAGE:</span> </td>
                        <td className='w-200'> <span className='eleHeader'>PRESCRIBING DOCTOR:</span> </td>
                        <td className='w-200'> <span className='eleHeader'>HOW LONG HAVE YOU BEEN TAKING THIS:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type='text' id='txtMedication_1' name='txtMedication_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtDosage_1' name='txtDosage_1' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtDoctor_1' name='txtDoctor_1' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtHowLong_1' name='txtHowLong_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type='text' id='txtMedication_2' name='txtMedication_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtDosage_2' name='txtDosage_2' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtDoctor_2' name='txtDoctor_2' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtHowLong_2' name='txtHowLong_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type='text' id='txtMedication_3' name='txtMedication_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtDosage_3' name='txtDosage_3' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtDoctor_3' name='txtDoctor_3' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtHowLong_3' name='txtHowLong_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type='text' id='txtMedication_4' name='txtMedication_4' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtDosage_4' name='txtDosage_4' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtDoctor_4' name='txtDoctor_4' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtHowLong_4' name='txtHowLong_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type='text' id='txtMedication_5' name='txtMedication_5' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtDosage_5' name='txtDosage_5' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtDoctor_5' name='txtDoctor_5' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtHowLong_5' name='txtHowLong_5' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type='text' id='txtMedication_6' name='txtMedication_6' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtDosage_6' name='txtDosage_6' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtDoctor_6' name='txtDoctor_6' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtHowLong_6' name='txtHowLong_6' className='add-only' /> </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>Have you seen any other doctors since your last visit? Why?:</span>
                    <textarea id='txtAnyOtherDoc' name='txtAnyOtherDoc' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Were there any medications prescribed? </span>
                    <span className='small'>(If yes, please list them )</span>
                    <input type='radio' id='rbAnyMedicationsPrescribed_Yes' name='rbAnyMedicationsPrescribed' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbAnyMedicationsPrescribed_No' name='rbAnyMedicationsPrescribed' className='add-only' value='No' /> No
                    <br />
                    <textarea id='txtAnyMedicationsPrescribed' name='txtAnyMedicationsPrescribed' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is there potential for self-harm or harm to others?</span>
                    <input type='radio' id='rbPotentialForSelfHarm_Yes' name='rbPotentialForSelfHarm' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbPotentialForSelfHarm_No' name='rbPotentialForSelfHarm' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Are there any medications that you will need refilled today?:</span>
                    <span className='small'>(If so, please list them )</span>
                    <input type='radio' id='rbMedicationsRefilled_Yes' name='rbMedicationsRefilled' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbMedicationsRefilled_No' name='rbMedicationsRefilled' className='add-only' value='No' /> No
                    <br />
                    <textarea id='txtMedicationsRefilled' name='txtMedicationsRefilled' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Do you have any known drug allergies?:</span>
                    <span className='small'>(If so please list them)</span>
                    <textarea id='txtDrugAllergies' name='txtDrugAllergies' className='add-only'></textarea>


                </p>
                <p>

                    <center> <h3> Progress Note</h3></center>
                </p>

                <table>
                    <tr>
                    <td className='w-375'><span className='eleHeader'>Patient Name:</span></td> 
                    <td className='w-375'><span className='eleHeader'>Date:</span></td>
                    </tr>
                    <tr>
                    <td className='w-375'><input type='text' id='txtProgressNotePatientName' name='txtProgressNotePatientName' className='add-only' /></td>
                    <td className='w-375'><input type='date' id='txtProgressNoteDate' name='txtProgressNoteDate' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-187'> <span className='eleHeader'>B/P:</span> </td>
                        <td className='w-187'> <span className='eleHeader'>Pulse:</span> </td>
                        <td className='w-187'> <span className='eleHeader'>Temp:</span> </td>
                        <td className='w-187'> <span className='eleHeader'>Weight:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'> <input type='text' id='txtBp' name='txtBp' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtPulse' name='txtPulse' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtTemp' name='txtTemp' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtWeight' name='txtWeight' className='add-only' /> </td>
                    </tr>
                </table>
                <p>
                <span className='eleHeader'>Session Information:</span>
                <textarea id='txtProgressNote' name='txtProgressNote' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>RTC:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Weeks:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Months:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtRtc' name='txtRtc' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtWeeks' name='txtWeeks' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtMonth' name='txtMonth' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Session Type:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Medication Change:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbSessionType_1' name='rbSessionType' className='add-only' value='1' /> Hour &nbsp;
                            <input type='radio' id='rbSessionType_2' name='rbSessionType' className='add-only' value='2' /> Med Check &nbsp;
                            <input type='radio' id='rbSessionType_3' name='rbSessionType' className='add-only' value='3' /> 30 Min.
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbMedicationChange_1' name='rbMedicationChange' className='add-only' value='1' /> Decrease  &nbsp;
                            <input type='radio' id='rbMedicationChange_2' name='rbMedicationChange' className='add-only' value='2' /> Increase &nbsp;
                            <input type='radio' id='rbMedicationChange_3' name='rbMedicationChange' className='add-only' value='3' /> Discontinued &nbsp;
                            <input type='radio' id='rbMedicationChange_4' name='rbMedicationChange' className='add-only' value='4' /> New
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>CONSULT TO PCP:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Refer to Brain Train:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtConsultPcp' name='txtConsultPcp' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtReferBrainTrain' name='txtReferBrainTrain' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Therapy:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Staff Verifying Referral:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtTherapy' name='txtTherapy' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtStaffVerifyingReferral' name='txtStaffVerifyingReferral' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Date:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Appt. Time:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='date' id='txtApptDate' name='txtApptDate' className='add-only' /> </td>
                        <td className='w-375'> <input type='time' id='txtApptTime' name='txtApptTime' className='add-only' /> </td>
                    </tr>
                </table>


            </div>
        </form>

    )
}   